// This file was automatically generated and should not be edited.

// ====================================================
// Core Object Capability Type Identity
// ====================================================

/** @package */
export const GeneratedPlatformCapability = {
  CORE_OBJECT_ARCHIVABLE: 'CORE_OBJECT_ARCHIVABLE',
  HAS_CUSTOM_FIELDS: 'HAS_CUSTOM_FIELDS',
  HAS_PROVENANCE_URI: 'HAS_PROVENANCE_URI',
  HAS_SCHEMA: 'HAS_SCHEMA',
  STARRABLE: 'STARRABLE',
  STUDYABLE: 'STUDYABLE',
} as const;

/** @package */
export const GeneratedDomainGraphInterface = {
  ...GeneratedPlatformCapability,
  CAN_EDIT_WORKFLOW_SCHEMA_FIELD_VALUES: 'CAN_EDIT_WORKFLOW_SCHEMA_FIELD_VALUES',
  COLLABORATABLE: 'COLLABORATABLE',
  DATA_CATALOG_ITEM: 'DATA_CATALOG_ITEM',
  EXTENSION_DEFINITION: 'EXTENSION_DEFINITION',
  EXTENSION_VERSION: 'EXTENSION_VERSION',
  IMMUTABLE_DOMAIN_OBJECT: 'IMMUTABLE_DOMAIN_OBJECT',
  MUTABLE_DOMAIN_OBJECT: 'MUTABLE_DOMAIN_OBJECT',
  PLATE_SCHEMA_INTERFACE: 'PLATE_SCHEMA_INTERFACE',
  PUBLISHABLE: 'PUBLISHABLE',
} as const;
